import styled from 'styled-components'

export const StyledDashboardOperationalWrapper = styled.div`
    display: grid;
    grid-template-rows: auto minmax(0, 1fr);
`
